import type React from 'react';

// Eagerly import all reseller logos
const resellerLogos = import.meta.glob<{ ResellerLogo: React.FC }>(
  '../../../reseller/*/logo/reseller-logo.tsx',
  { eager: true },
);

export const getResellerLogo = (reseller?: string): React.FC | undefined => {
  if (!reseller) return undefined;

  const entry = Object.entries(resellerLogos).find(([path]) =>
    path.includes(`/${reseller}/logo/reseller-logo.tsx`),
  );

  return entry?.[1].ResellerLogo;
};
